import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
const faqs = [{
  question: 'How do I schedule an appointment?',
  answer: 'Submit the appointment request form on this page. A medical coordinator will contact you within 24 hours to review availability and schedule your consultation with Dr. Mark Joy, MD.'
}, {
  question: 'Does submitting the form confirm my appointment?',
  answer: 'No, submitting the form is a request only. A medical coordinator will contact you to confirm availability and schedule your appointment at a mutually convenient time.'
}, {
  question: 'Are consultations available in Spanish?',
  answer: 'Yes, Dr. Mark Joy offers consultations in both English and Spanish. Please indicate your language preference when submitting your appointment request.'
}, {
  question: 'Are appointments confidential?',
  answer: 'Yes, all consultations are completely confidential and conducted in accordance with medical privacy standards. Your personal information and medical discussions are protected.'
}, {
  question: 'How long does an appointment take?',
  answer: 'Appointment length varies based on individual needs, but typically ranges from 30 to 60 minutes. The medical coordinator will provide specific details when scheduling your consultation.'
}, {
  question: 'What should I prepare for my appointment?',
  answer: 'Please be prepared to discuss your medical history, current concerns, and any questions you may have. If you have relevant medical records or documentation, bringing them can be helpful. The coordinator will provide additional preparation instructions when confirming your appointment.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full py-20 lg:py-24 bg-white relative overflow-hidden" data-id="element-76">
      <div className="absolute inset-0" data-id="element-77">
        <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-brand-aqua/10 rounded-full blur-3xl" data-id="element-78" />
        <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-brand-gold/10 rounded-full blur-3xl" data-id="element-79" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-81">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-gold/10 rounded-full mb-4" data-id="element-82">
            <HelpCircle className="w-4 h-4 text-brand-gold" data-id="element-83" />
            <span className="text-brand-gold font-semibold text-sm uppercase tracking-wider" data-id="element-84">
              Common Questions
            </span>
          </div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-brand-navy mb-6" data-id="element-85">
            Frequently Asked{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-primary to-brand-gold" data-id="element-86">
              Questions
            </span>
          </h2>
          <p className="text-xl text-gray-600" data-id="element-87">
            Learn more about the consultation process
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-88">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl shadow-lg border border-brand-gold/10 overflow-hidden" data-id="element-89">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-brand-aqua/5 transition-colors duration-300" data-id="element-90">
                <span className="text-lg font-bold text-brand-navy pr-4" data-id="element-91">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="flex-shrink-0" data-id="element-92">
                  <ChevronDown className="w-6 h-6 text-brand-gold" data-id="element-93" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-94">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-95">
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed" data-id="element-96">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}